import styled from 'styled-components';
import { IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { Delete as DeleteIcon, FilterList as FilterListIcon } from '@mui/icons-material';
import Filters from 'shared/Filters';
import { FilterProps } from 'types';

const TableTitle = styled(Typography)`
  width: 100%;
`;

const OptionsContainer = styled.div`
  width: 100%;
`;

export type TableToolbarPropsType = {
  numSelected?: number;
  tableTitle: string;
  renderOptions?: () => JSX.Element;
  hideFilterIcon?: boolean;
  filtersToShow?: FilterProps;
};
const TableToolbar = (props: TableToolbarPropsType) => {
  const {
    numSelected,
    tableTitle = '',
    renderOptions,
    hideFilterIcon = true,
    filtersToShow,
  } = props;

  // Always show bottom border for consistent spacing
  const showBottomBorder = true;

  return (
    <>
      <Toolbar
        className="toolbar"
        sx={{
          px: 4,
          py: 2.5,
          minHeight: '72px',
          borderBottom: (theme) =>
            theme.palette.mode === 'dark'
              ? '1px solid rgba(148, 163, 184, 0.12)'
              : '1px solid rgba(226, 232, 240, 0.6)',
          background: (theme) =>
            theme.palette.mode === 'dark'
              ? 'linear-gradient(180deg, rgba(30, 41, 59, 0.4) 0%, transparent 100%)'
              : 'linear-gradient(180deg, rgba(248, 250, 252, 0.6) 0%, transparent 100%)',
        }}
      >
        {tableTitle && (
          <TableTitle
            variant="h6"
            id="tableTitle"
            className="table-title"
            sx={{
              fontSize: '1.125rem',
              fontWeight: 700,
              letterSpacing: '-0.01em',
              background: (theme) =>
                theme.palette.mode === 'dark'
                  ? 'linear-gradient(135deg, #f8fafc 0%, #cbd5e1 100%)'
                  : 'linear-gradient(135deg, #1e293b 0%, #475569 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
            }}
          >
            {tableTitle}
          </TableTitle>
        )}
        <div>
          {numSelected && numSelected > 0 && (
            <Typography
              variant="subtitle1"
              sx={{
                color: 'inherit',
              }}
            >
              {numSelected} selected
            </Typography>
          )}
        </div>
        <div>
          {numSelected && numSelected > 0 ? (
            <Tooltip title="Delete">
              <IconButton aria-label="Delete">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            !hideFilterIcon && (
              <Tooltip title="Filter list">
                <IconButton aria-label="Filter list">
                  <FilterListIcon />
                </IconButton>
              </Tooltip>
            )
          )}
        </div>
      </Toolbar>
      <OptionsContainer className="option-container">
        {renderOptions && renderOptions()}
      </OptionsContainer>
      {filtersToShow && filtersToShow.sections.length > 0 && (
        <Filters
          filterSections={filtersToShow.sections}
          filtersProps={filtersToShow.filtersProps}
        />
      )}
    </>
  );
};

export default TableToolbar;
